import React from "react";
import "./InformationalPages.css";
import useTitle from '../hooks/useTitle';
import "./About.css"; // Use the CSS from Terms of Use for styling

const Privacy = () => {
    useTitle('Privacy Policy');

    return (
        <div className="ffls-info-page">
            <div className="login-box ffls-info-panel">
                <h1>Privacy Policy</h1>
                <span className="effective-date">Effective Date: {new Date().toLocaleDateString()}</span>

                <p>
                    This Privacy Policy explains how <strong>FFLs.io</strong> (“we,” “our,” or “us”)
                    collects, uses, discloses, and safeguards your information when you access or use our website,
                    mobile applications, and related services (collectively, the “Services”).
                </p>

                <h2>1. Information We Collect</h2>
                <ul>
                    <li><strong>Personal Information:</strong> Name, email address, account details, and any other identifiers you provide when registering or interacting with our Services.</li>
                    <li><strong>Business Information:</strong> FFL license details, dealer name, location, and other information relevant to your listing.</li>
                    <li><strong>Technical Information:</strong> IP address, browser type, operating system, device identifiers, and usage data collected via cookies and similar technologies.</li>
                    <li><strong>Uploaded Content:</strong> Files, images, documents, and any data submitted through our Services.</li>
                </ul>

                <h2>2. How We Use Your Information</h2>
                <p>We use collected information for purposes including but not limited to:</p>
                <ul>
                    <li>Providing, maintaining, and improving our Services.</li>
                    <li>Verifying your identity and FFL credentials.</li>
                    <li>Facilitating communications between you and potential customers.</li>
                    <li>Sending service-related notifications, updates, or promotional offers (you may opt out at any time).</li>
                    <li>Complying with legal obligations and regulatory requirements.</li>
                </ul>

                <h2>3. How We Share Your Information</h2>
                <ul>
                    <li>With third-party service providers who perform functions on our behalf (e.g., hosting, payment processing, analytics).</li>
                    <li>When required by law, subpoena, or legal process, or to protect our legal rights and the safety of others.</li>
                    <li>In connection with a business transfer, such as a merger, acquisition, or sale of assets.</li>
                    <li>With your consent or at your direction.</li>
                </ul>

                <h2>4. Cookies & Tracking Technologies</h2>
                <p>
                    We use cookies, pixels, and similar technologies to enhance your browsing experience, analyze usage, and
                    deliver personalized content. You can manage cookie preferences through your browser settings,
                    though some features may not function properly without them.
                </p>

                <h2>5. Data Security</h2>
                <p>
                    We implement reasonable administrative, technical, and physical safeguards to protect your
                    information from unauthorized access, use, or disclosure. However, no method of transmission over
                    the Internet or method of electronic storage is 100% secure.
                </p>

                <h2>6. Data Retention</h2>
                <p>
                    We retain your information only as long as necessary to fulfill the purposes outlined in this Privacy Policy,
                    unless a longer retention period is required or permitted by law.
                </p>

                <p>
                    To honor mailing-list unsubscribe requests, we retain readable email addresses for up to three calendar years
                    after withdrawal, solely for suppression management and compliance. This is our retention policy, not a universal
                    legal requirement. Earlier removal may occur when required by applicable law or a verified deletion request,
                    subject to lawful retention exceptions, including valid legal holds. After readable addresses are removed,
                    necessary suppression hashes and consent evidence may remain to honor the opt-out. Suppression records do not
                    authorize marketing or automatically reactivate a subscription.
                </p>

                <h2>7. Your Rights</h2>
                <ul>
                    <li>Request access to the personal information we hold about you.</li>
                    <li>Request correction or deletion of your personal information.</li>
                    <li>Opt out of marketing communications.</li>
                    <li>Restrict certain processing or request data portability where applicable by law.</li>
                </ul>

                <h2>8. Third-Party Links & Services</h2>
                <p>
                    Our Services may contain links to third-party websites or services. We are not responsible for
                    the privacy practices of those third parties. We encourage you to review their privacy policies.
                </p>

                <h2>9. Children’s Privacy</h2>
                <p>
                    Our Services are not directed toward individuals under the age of 18, and we do not knowingly
                    collect personal information from children.
                </p>

                <h2>10. Changes to This Privacy Policy</h2>
                <p>
                    We may update this Privacy Policy from time to time. We will notify you of any material changes
                    by posting the new policy on this page and updating the “Effective Date” above.
                </p>

                <h2>11. Contact Us</h2>
                <p>
                    If you have any questions or concerns about this Privacy Policy or our data practices, please email us at:&nbsp;
                    <a href="mailto:support@ffls.io">support@ffls.io</a>
                </p>
            </div>
        </div>
    );
};

export default Privacy;